<template>
  <b-row class="text-center date">
    <b-col class="p-0">
      <div class>— {{itemData.tempMonth}} {{itemData.tempDay}} —</div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "DateView",
  mounted(){
    this.recbus();
    this.getNewDate();
  },
  props:['itemData'],
  mounted(){
    // console.log(this.itemData);
  },
  methods: {
    getNewDate(){
      var tempDate = new Date();
      // console.log(tempDate,'tempDate')
    },
    recbus() {
      this.$EventBus.$on("bus", msg => {
        // console.log("事件总线接收成功");
      });
    }
  }
};
</script>

<style scoped>
.date {
  font-size: 18px;
  font-family: Fontdate;
  letter-spacing: 3px;
  line-height: 61px;
  color: #220C57;
}
</style>